import React from "react";
import { SlideManager } from "components/organisms/CommonUI/SlidePopup/SlideManager";
import DoseReviewTestPanel from "./DoseReviewTestPanel";

/**
 * 우측 슬라이드로 처방 판정 테스트 패널을 연다(설계 결정 12, openDrugLabelSlide 패턴).
 * width 800px · 배경 있음(noBackdrop 없음). 호출마다 고유 key를 붙여, 닫는 애니메이션(500ms)
 * 도중 다시 열려도 이전 입력 상태가 재사용되지 않게 한다(AC-19).
 */
let openSeq = 0;

export function openDoseReviewTestSlide(params: { onOpenRule: (ruleId: string) => void }) {
  const key = `dose-review-panel-${++openSeq}`;
  SlideManager.show({
    body: <DoseReviewTestPanel key={key} onOpenRule={params.onOpenRule} />,
    width: "800px",
    needCloseButton: true,
    direction: "right",
  });
}
